document.addEventListener('DOMContentLoaded', function () {
  /* eslint-disable no-unused-vars, no-undef */
  const featuredProductSlider = document.getElementById('featured-product-slider')
  const featuredProductThumbs = document.getElementById('featured-product-slider-thumb')

  if (featuredProductSlider.swiper) {
    featuredProductSlider.swiper.destroy(true, true)
    const swiperfps = new Swiper('#featured-product-slider', {
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      zoom: {
        maxRatio: 1.75,
        minRatio: 1,
        toggle: true,
        zoomedSlideClass: 'swiper-slide-zoomed'
      },
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: false
      },
      spaceBetween: 26,
      thumbs: {
        swiper: featuredProductThumbs
      },
      breakpoints: {
        576: {
          spaceBetween: 40
        },
        768: {
          effect: 'slide'
        },
        1250: {
          effect: 'slide',
          spaceBetween: 20
        }
      },
      on: {
        init: function () {
          const zoomContainers = document.querySelectorAll('.swiper-zoom-container')
          zoomContainers.forEach(container => {
            container.removeEventListener('dblclick', container._zoomEvents?.onGestureStart)
            container.addEventListener('click', function (e) {
              if (swiperfps.zoom.scale === 1) {
                swiperfps.zoom.in()
              } else {
                swiperfps.zoom.out()
              }
            })
          })
        },
        slideChangeTransitionStart: function () {
          const slides = this.slides
          slides.forEach((slide, index) => {
            if (index === this.activeIndex) {
              slide.style.height = '100%'
            } else {
              slide.style.height = '80%'
            }
          })
        }
      }
    })
  }

  if (featuredProductThumbs) {
    featuredProductThumbs.swiper.destroy(true, true)
    const swiperfpt = new Swiper('#featured-product-slider-thumb', {
      slidesPerView: 'auto',
      spaceBetween: 16,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      breakpoints: {
        1250: {
          direction: 'vertical'
        }
      }
    })
  }
})
